<template>
  <normalDialog
    :height="700"
    maxWidth="700"
    :width="700"
    @close="closeDialog"
    scrollable
    :title="$t('label_essweb_approvalTemplate_form_dialog_viewNodeTitle')"
    :dialog="show"
  >
    <template v-slot:content>
      <Taber
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        special
        backgroundColor="white"
      >
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row dense>
              <v-col dense xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :bindData="approvalNodeData.flow_template_node_name"
                  @change="
                    (valueArr) => {
                      approvalNodeData.flow_template_node_name = valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_approvalTemplate_form_dialog_nodeNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col dense xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :bindData="approvalNodeData.flow_template_node_description"
                  @change="
                    (valueArr) => {
                      approvalNodeData.flow_template_node_description =
                        valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_approvalTemplate_form_dialog_descriptionLabel'
                    )
                  "
                />
              </v-col>
              <v-col dense xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_approvalTemplate_form_dialog_remarkLabel")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  maxlength="500"
                  single-line
                  dense
                  counter="500"
                  v-model="approvalNodeData.remarks"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-form lazy-validation>
            <v-row dense>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">
                  {{
                    $t("label_essweb_approvalTemplate_form_dialog_actionLabel")
                  }}
                </v-sheet>
                <v-select
                  dense
                  single-line
                  append-icon=""
                  multiple
                  v-model="curAction"
                  readonly
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  :items="actionList"
                >
                  <template v-slot:no-data>
                    <noContent />
                  </template>
                  <template
                    v-slot:selection="{ attrs, item, parent, selected }"
                  >
                    {{
                      $t(item) +
                      (curAction[curAction.length - 1] == item ? "" : ",")
                    }}
                  </template>
                </v-select>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :readonly="true"
                  :filled="false"
                  :value="
                    Number(approvalNodeData.is_alert_notification)
                      ? $t('label_essweb_system_label_trueLabel')
                      : $t('label_essweb_system_label_falseLabel')
                  "
                  :label="
                    $t(
                      'label_essweb_approvalTemplate_form_dialog_notificationLabel'
                    )
                  "
                  dense
                />
              </v-col>
              <v-col
                xs="12"
                sm="12"
                md="12"
                lg="12"
                cols="12"
                v-if="Number(approvalNodeData.is_alert_notification)"
              >
                <normalInputTextFiled
                  type="text"
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  v-model="approvalNodeData.approver_notify_threshold"
                  :label="
                    $t(
                      'label_essweb_approvalTemplate_form_dialog_approvalNotiOverDateLabel'
                    )
                  "
                >
                </normalInputTextFiled>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="pl-1 text--secondary">
                  {{
                    $t(
                      "label_essweb_approvalTemplate_form_dialog_approverLabel"
                    )
                  }}

                  <!-- <span v-if="approvers != null && Number(approvers) === 0"
                    >{{
                      $t(
                        "label_essweb_approvalTemplate_form_dialog_senderSupervisorLabel"
                      )
                    }}
                  </span> -->
                  <!-- <span v-if="Number(approvers) === 1"
                    >{{
                      $t(
                        "label_essweb_approvalTemplate_form_dialog_approverSupervisorLabel"
                      )
                    }}
                  </span> -->
                  <span v-if="Number(approvers) === 2">
                    ({{
                      $t(
                        "label_essweb_approvalTemplate_form_dialog_approverJobLabel"
                      )
                    }})
                  </span>
                  <span v-if="Number(approvers) === 3">
                    ({{
                      $t(
                        "label_essweb_approvalTemplate_form_dialog_staffLabel"
                      )
                    }})
                  </span>
                  <span v-if="Number(approvers) === 4"
                    >({{
                      $t(
                        "label_essweb_approvalTemplate_form_dialog_nodalApproverLabel"
                      )
                    }})
                  </span>
                  <span v-if="Number(approvers) === 5">
                    ({{
                      $t(
                        "label_essweb_approvalTemplate_form_dialog_nodalApproverSupervisorLabel"
                      )
                    }})
                  </span>
                  <span v-if="Number(approvers) === 7"
                    >({{
                      $t(
                        "label_essweb_approvalTemplate_form_dialog_senderStaffShipLabel"
                      )
                    }})
                  </span>
                </v-sheet>
                <!-- 提交人上司 -->
                <template v-if="approvers != null && Number(approvers) == 0">
                  <normalInputTextFiled
                    :readonly="true"
                    :filled="false"
                    :value="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_senderSupervisorLabel'
                      )
                    "
                    :showLabel="false"
                    dense
                  />
                </template>
                <!-- 申请人上司 -->
                <template v-if="Number(approvers) == 1">
                  <normalInputTextFiled
                    :readonly="true"
                    :filled="false"
                    :value="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_approverSupervisorLabel'
                      )
                    "
                    :showLabel="false"
                    dense
                  />
                </template>
                <!-- 指定岗位 -->
                <template v-if="Number(approvers) == 2">
                  <v-autocomplete
                    v-model="approvalNodeData.forJob"
                    :items="allJob"
                    chips
                    :deletable-chips="false"
                    multiple
                    append-icon=""
                    hide-details
                    :filter="jobFliter"
                    single-line
                    readonly
                    color="primary lighten-2"
                    item-text="view_fields"
                    item-value="value_field"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="removeJob(data.item)"
                      >
                        {{ $getCommonLangValue(data.item.view_fields) }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </template>
                <!-- 指定员工 -->
                <template v-if="Number(approvers) == 3">
                  <AutoComplete
                    v-model="approvalNodeData.Staffs"
                    :items="allStaff"
                    chips
                    multiple
                    :filter="$staffFilter"
                    readonly
                    avatar
                    small-chips
                    hide-details
                    item-text="staff_code"
                    item-value="staff_id"
                  >
                    <template v-slot:selection.avatar="{ data }">
                      <StaffAvatar
                        left
                        small
                        :src="data.item.staff_avatar"
                        :staff_name="data.item.preferred_name"
                      />
                    </template>
                    <template v-slot:selection="{ data }">
                      {{ $getCommonLangValue(data.item.preferred_name) }}
                    </template>
                  </AutoComplete>
                </template>
                <!--  节点审批人 -->
                <template v-if="Number(approvers) == 4">
                  <v-autocomplete
                    v-model="approvalNodeData.applicantMan"
                    :items="allNode"
                    chips
                    hide-details
                    :deletable-chips="false"
                    single-line
                    readonly
                    append-icon=""
                    item-text="flow_template_node_name"
                    :item-value="curUuid ? 'uuid' : 'number'"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="approvalNodeData.applicantMan = ''"
                      >
                        {{
                          $getCommonLangValue(data.item.flow_template_node_name)
                        }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%" nav>
                        <v-list-item rouned width="100%">
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_name
                                )
                              "
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_description
                                )
                              "
                            ></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </template>
                <!--  节点审批上司 -->
                <template v-if="Number(approvers) == 5">
                  <v-autocomplete
                    v-model="approvalNodeData.applicantHeader"
                    :items="allNode"
                    chips
                    :deletable-chips="false"
                    hide-details
                    single-line
                    readonly
                    append-icon=""
                    color="primary lighten-2"
                    item-text="flow_template_node_name"
                    :item-value="curUuid ? 'uuid' : 'number'"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="approvalNodeData.applicantHeader = ''"
                      >
                        {{
                          $getCommonLangValue(data.item.flow_template_node_name)
                        }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%">
                        <v-list-item rouned width="100%">
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_name
                                )
                              "
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_description
                                )
                              "
                            ></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </template>
                <!--  全部上司 -->
                <template v-if="Number(approvers) == 6">
                  <normalInputTextFiled
                    :readonly="true"
                    :filled="false"
                    :value="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_senderAllSupervisorLabel'
                      )
                    "
                    :showLabel="false"
                    dense
                  />
                </template>
                <!--  节点审批上司 -->
                <template v-if="Number(approvers) == 7">
                  <v-autocomplete
                    v-model="approvalNodeData.correlation"
                    :items="allShip"
                    chips
                    :deletable-chips="false"
                    multiple
                    append-icon=""
                    hide-details
                    :filter="shipFliter"
                    single-line
                    readonly
                    color="primary lighten-2"
                    item-text="view_fields"
                    item-value="value_field"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="removeShip(data.item)"
                      >
                        {{ $getCommonLangValue(data.item.view_fields) }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%" nav>
                        <v-list-item rouned width="100%" nav>
                          <!-- <v-list-item-avatar>
                                <img :src="data.item.f1" />
                              </v-list-item-avatar> -->
                          <v-list-item-content>
                            <v-list-item-title>{{
                              $getCommonLangValue(data.item.view_fields)
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </template>
              </v-col>
              <!-- 抄送 -->
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="pl-1 text--secondary">
                  {{
                    $t("label_essweb_approvalTemplate_form_dialog_emailCCLabel")
                  }}
                  <!-- <span v-if="Number(copySender) === -1">
                    ({{
                      $t(
                        "label_essweb_approvalTemplate_form_dialog_notCCLabel"
                      )
                    }})
                  </span> -->
                  <span v-if="Number(copySender) === 2">
                    ({{
                      $t(
                        "label_essweb_approvalTemplate_form_dialog_approverJobLabel"
                      )
                    }})
                  </span>
                  <span v-if="Number(copySender) === 3">
                    ({{
                      $t(
                        "label_essweb_approvalTemplate_form_dialog_staffLabel"
                      )
                    }})
                  </span>
                  <span v-if="Number(copySender) === 4"
                    >({{
                      $t(
                        "label_essweb_approvalTemplate_form_dialog_nodalApproverLabel"
                      )
                    }})
                  </span>
                  <span v-if="Number(copySender) === 5">
                    ({{
                      $t(
                        "label_essweb_approvalTemplate_form_dialog_nodalApproverSupervisorLabel"
                      )
                    }})
                  </span>
                  <span v-if="Number(copySender) === 7"
                    >({{
                      $t(
                        "label_essweb_approvalTemplate_form_dialog_senderStaffShipLabel"
                      )
                    }})
                  </span>
                </v-sheet>
                <template v-if="copySender == -1">
                  <normalInputTextFiled
                    :readonly="true"
                    :filled="false"
                    :value="
                      $t('label_essweb_approvalTemplate_form_dialog_notCCLabel')
                    "
                    :showLabel="false"
                    dense
                  />
                </template>
                <!-- 提交人上司 -->
                <template v-if="copySender != null && Number(copySender) == 0">
                  <normalInputTextFiled
                    :readonly="true"
                    :filled="false"
                    :value="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_senderSupervisorLabel'
                      )
                    "
                    :showLabel="false"
                    dense
                  />
                </template>
                <!-- 申请人上司 -->
                <template v-if="Number(copySender) == 1">
                  <normalInputTextFiled
                    :readonly="true"
                    :filled="false"
                    :value="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_approverSupervisorLabel'
                      )
                    "
                    :showLabel="false"
                    dense
                  />
                </template>
                <!-- 指定岗位 -->
                <template v-if="Number(copySender) == 2">
                  <v-autocomplete
                    v-model="approvalNodeData.forJob_cc"
                    :items="allJob"
                    chips
                    :deletable-chips="false"
                    multiple
                    append-icon=""
                    hide-details
                    :filter="jobFliter"
                    single-line
                    readonly
                    color="primary lighten-2"
                    item-text="view_fields"
                    item-value="value_field"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="removeJob(data.item, true)"
                      >
                        {{ $getCommonLangValue(data.item.view_fields) }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list class="pa-0" width="100%" nav>
                        <v-list-item rouned width="100%" nav two-line dense>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              $getCommonLangValue(data.item.view_fields)
                            }}</v-list-item-title>
                            <v-list-item-subtitle>{{
                              $getCommonLangValue(data.item.f1)
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </template>
                <!-- 指定员工 -->
                <template v-if="Number(copySender) == 3">
                  <v-autocomplete
                    v-model="approvalNodeData.Staffs_cc"
                    :items="allStaff"
                    chips
                    multiple
                    :filter="$staffFilter"
                    readonly
                    append-icon=""
                    :deletable-chips="false"
                    hide-details
                    single-line
                    item-text="staff_code"
                    item-value="staff_id"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        pill
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="removeStaff(data.item, true)"
                      >
                        <StaffAvatar
                          left
                          :src="data.item.staff_avatar"
                          :staff_name="data.item.preferred_name"
                        />
                        {{ $getCommonLangValue(data.item.preferred_name) }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%" nav two-line dense>
                        <v-list-item rouned width="100%" nav>
                          <v-list-item-avatar
                            class="ma-0 mr-1 white--text"
                            size="36"
                          >
                            <StaffAvatar
                              size="36"
                              :src="data.item.staff_avatar"
                              :staff_name="data.item.preferred_name"
                            />
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="text-body-2"
                              >{{
                                $getCommonLangValue(data.item.preferred_name)
                              }}
                              <span class="text--secondary text-caption-xs">{{
                                data.item.staff_code
                              }}</span></v-list-item-title
                            >
                            <v-list-item-subtitle>{{
                              $getCommonLangValue(data.item.job_post_name)
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </template>
                <!--  节点审批人 -->
                <template v-if="Number(copySender) == 4">
                  <v-autocomplete
                    v-model="approvalNodeData.applicantMan_cc"
                    :items="allNode"
                    chips
                    hide-details
                    :deletable-chips="false"
                    single-line
                    readonly
                    append-icon=""
                    item-text="flow_template_node_name"
                    :item-value="curUuid ? 'uuid' : 'number'"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="approvalNodeData.applicantMan_cc = ''"
                      >
                        {{
                          $getCommonLangValue(data.item.flow_template_node_name)
                        }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%" nav>
                        <v-list-item rouned width="100%">
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_name
                                )
                              "
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_description
                                )
                              "
                            ></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </template>
                <!--  节点审批上司 -->
                <template v-if="Number(copySender) == 5">
                  <v-autocomplete
                    v-model="approvalNodeData.applicantHeader_cc"
                    :items="allNode"
                    chips
                    :deletable-chips="false"
                    hide-details
                    single-line
                    readonly
                    append-icon=""
                    color="primary lighten-2"
                    item-text="flow_template_node_name"
                    :item-value="curUuid ? 'uuid' : 'number'"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="approvalNodeData.applicantHeader_cc = ''"
                      >
                        {{
                          $getCommonLangValue(data.item.flow_template_node_name)
                        }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%">
                        <v-list-item rouned width="100%">
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_name
                                )
                              "
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_description
                                )
                              "
                            ></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </template>
                <!--  全部上司 -->
                <template v-if="Number(copySender) == 6">
                  <normalInputTextFiled
                    :readonly="true"
                    :filled="false"
                    :value="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_senderAllSupervisorLabel'
                      )
                    "
                    :showLabel="false"
                    dense
                  />
                </template>
                <!--  节点审批上司 -->
                <template v-if="Number(copySender) == 7">
                  <v-autocomplete
                    v-model="approvalNodeData.correlation_cc"
                    :items="allShip"
                    chips
                    :deletable-chips="false"
                    multiple
                    append-icon=""
                    hide-details
                    :filter="shipFliter"
                    single-line
                    readonly
                    color="primary lighten-2"
                    item-text="view_fields"
                    item-value="value_field"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="removeShip(data.item, true)"
                      >
                        {{ $getCommonLangValue(data.item.view_fields) }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%" nav>
                        <v-list-item rouned width="100%" nav>
                          <!-- <v-list-item-avatar>
                                <img :src="data.item.f1" />
                              </v-list-item-avatar> -->
                          <v-list-item-content>
                            <v-list-item-title>{{
                              $getCommonLangValue(data.item.view_fields)
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </template>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-3>
          <v-form ref="form2" lazy-validation>
            <v-row>
              <v-col dense xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_approvalTemplate_form_dialog_filedLabel")
                }}</v-sheet>
                <v-autocomplete
                  :items="allField"
                  item-text="view_fields"
                  item-value="value_field"
                  small-chips
                  single-line
                  :readonly="!iSEdited"
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  :filled="iSEdited"
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  deletable-chips
                  v-model="approvalNodeData.field_uuid"
                  multiple
                >
                  <template v-slot:no-data>
                    <noContent />
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="data.item.view_fields"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </template>
      </Taber>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn v-if="iSEdited" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "newApprovalDialog",
  computed: {
    ...mapGetters(["companyLang", "staticZone", "AppInfo"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
  },
  props: {
    show: { default: false, type: Boolean },
    PropertyData: { default: null, type: Object },
    allNode: { default: [], type: Array },
    table: { default: "", type: String },
    curUuid: { default: "", type: String },
  },
  watch: {
    curUuid(val) {
      //在线编辑
      if (val) {
        this.getDetail(val);
      }
    },
    PropertyData(obj) {
      this.curTab = "tab-1";
      const that = this;
      if (obj) {
        this.actions = [];
        this.curAction = [];
        obj.is_allow_forward ? this.actions.push(0) : null;
        obj.is_allow_forward ? this.curAction.push(this.actionList[0]) : null;
        obj.is_allow_revoke ? this.actions.push(1) : null;
        obj.is_allow_revoke ? this.curAction.push(this.actionList[1]) : null;
        obj.is_allow_rollback ? this.actions.push(2) : null;
        obj.is_allow_rollback ? this.curAction.push(this.actionList[2]) : null;
        obj.is_allow_skip ? this.actions.push(3) : null;
        obj.is_allow_skip ? this.curAction.push(this.actionList[3]) : null;
        obj.is_allow_view_attachments ? this.actions.push(4) : null;
        obj.is_allow_view_attachments
          ? this.curAction.push(this.actionList[4])
          : null;
        this.approvalNodeData.is_first_sequence = obj.is_first_sequence;
        this.approvalNodeData.is_final_sequence = obj.is_final_sequence;
        this.notifications = [];
        obj.is_alert_notification ? this.notifications.push(0) : null;
        // 2021-01-11 改为一个通知 brain
        // obj.is_alert_notification ? this.notifications.push(0) : null;
        // obj.is_alert_prev_approver ? this.notifications.push(1) : null;
        this.approvers = -1;
        obj.ess_workflow_template_node_permission[0].is_leader_of_sender === 0
          ? (this.approvers = 0)
          : null;
        obj.ess_workflow_template_node_permission[0].is_leader_of_sender === 1
          ? (this.approvers = 0)
          : null;
        obj.ess_workflow_template_node_permission[0].is_leader_of_applicant
          ? (this.approvers = 1)
          : null;
        obj.ess_workflow_template_node_permission[0].approval_postion_uuid
          ? (this.approvers = 2)
          : null;
        obj.ess_workflow_template_node_permission[0].approval_staff_uuid
          ? (this.approvers = 3)
          : null;
        if (
          obj.ess_workflow_template_node_permission[0].pre_node_approver !==
            null &&
          obj.ess_workflow_template_node_permission[0].pre_node_approver !== ""
        ) {
          this.approvers = 4;
        }
        if (
          obj.ess_workflow_template_node_permission[0]
            .pre_node_approver_leader !== null &&
          obj.ess_workflow_template_node_permission[0]
            .pre_node_approver_leader !== ""
        ) {
          this.approvers = 5;
        }
        obj.ess_workflow_template_node_permission[0].approval_org_level_uuid
          ? (that.approvers = 6)
          : null;
        this.approvalNodeData.flow_template_node_name =
          this.$transOnLineCommonLangKey(
            this.companyLang,
            obj.flow_template_node_name
          );
        this.approvalNodeData.flow_template_node_description =
          this.$transOnLineCommonLangKey(
            this.companyLang,
            obj.flow_template_node_description
          );

        this.approvalNodeData.applicantMan =
          obj.ess_workflow_template_node_permission[0].pre_node_approver;
        this.approvalNodeData.applicantHeader =
          obj.ess_workflow_template_node_permission[0].pre_node_approver_leader;
        let job = obj.ess_workflow_template_node_permission[0]
          .approval_postion_uuid
          ? obj.ess_workflow_template_node_permission[0].approval_postion_uuid.split(
              ","
            )
          : [];
        job.map((item) => {
          that.approvalNodeData.forJob.push(item);
        });
        that.approvalNodeData.Staffs = [];
        let staff = obj.ess_workflow_template_node_permission[0]
          .approval_staff_uuid
          ? obj.ess_workflow_template_node_permission[0].approval_staff_uuid.split(
              ","
            )
          : [];
        staff.map((item) => {
          that.approvalNodeData.Staffs.push(Number(item));
        });
        let ship = obj.ess_workflow_template_node_permission[0].correlation_uuid
          ? obj.ess_workflow_template_node_permission[0].correlation_uuid.split(
              ","
            )
          : [];
        that.approvalNodeData.correlation = [];
        ship.map((item) => {
          that.approvalNodeData.correlation.push(item);
        });
        this.approvalNodeData.field_uuid =
          obj.ess_workflow_template_node_allow_update_fields[0].field_uuid.split(
            ","
          );
        this.approvalNodeData.remarks = obj.remarks;
        this.approvalNodeData["number"] = obj.number;
        this.approvalNodeData["id"] = obj.id;
      }
    },
    show(val) {
      // if (!val) {
      //   this.approvalNodeData.is_allow_forward = false;
      //   this.approvalNodeData.is_allow_revoke = false;
      //   this.approvalNodeData.is_allow_rollback = false;
      //   this.approvalNodeData.is_first_sequence = false;
      //   this.approvalNodeData.is_final_sequence = false;
      //   this.approvalNodeData.is_alert_notification = false;
      //   this.approvalNodeData.is_alert_prev_approver = false;
      //   this.approvalNodeData.is_leader_of_sender = false;
      //   this.approvalNodeData.is_leader_of_applicant = true;
      //   this.approvalNodeData.is_for_job = false;
      //   this.approvalNodeData.is_for_staff = false;
      //   this.approvalNodeData.is_for_applicant = false;
      //   this.approvalNodeData.is_for_applicantheader = false;
      //   this.approvalNodeData.applicantMan = "";
      //   this.approvalNodeData.applicantHeader = "";
      //   this.approvalNodeData.Staffs = "";
      //   this.approvalNodeData.field_uuid = [];
      //   this.curTab = "tab-1";
      //   if (this.$refs["form"]) this.$refs["form"].reset();
      //   if (this.$refs["form2"]) this.$refs["form2"].reset();
      // }
      if (val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
        if (this.$refs["form2"]) this.$refs["form2"].reset();
      }
      if (!val) this.allField = [];
      this.curTab = "tab-1";
      if (this.allStaff.length == 0)
        this.$getStaffList().then((res) => {
          this.allStaff = res;
        });
      if (this.allField.length == 0 && this.table != "")
        this.getField(this.table);
    },
    table(val) {
      if (val) {
        this.getField(val);
      }
    },
    actions(val) {
      const index0 = val.indexOf(0);
      const index1 = val.indexOf(1);
      const index2 = val.indexOf(2);
      const index3 = val.indexOf(3);
      const index4 = val.indexOf(4);
      this.approvalNodeData.is_allow_forward = false;
      this.approvalNodeData.is_allow_revoke = false;
      this.approvalNodeData.is_allow_rollback = false;
      this.approvalNodeData.is_allow_skip = false;
      this.approvalNodeData.is_allow_view_attachments = false;

      if (index0 >= 0) {
        this.approvalNodeData.is_allow_forward = true;
      }
      if (index1 >= 0) {
        this.approvalNodeData.is_allow_revoke = true;
      }
      if (index2 >= 0) {
        this.approvalNodeData.is_allow_rollback = true;
      }
      if (index3 >= 0) {
        this.approvalNodeData.is_allow_skip = true;
      }
      if (index4 >= 0) {
        this.approvalNodeData.is_allow_view_attachments = true;
      }
    },
    nodes(val) {
      this.approvalNodeData.is_first_sequence = false;
      this.approvalNodeData.is_final_sequence = false;
      switch (val) {
        case 0:
          this.approvalNodeData.is_first_sequence = true;
          break;
        case 1:
          // this.approvalNodeData.
          break;
        case 2:
          this.approvalNodeData.is_final_sequence = true;
          break;
        default:
          break;
      }
    },
    notifications(val) {
      const index0 = val.indexOf(0);
      // const index1 = val.indexOf(1);
      this.approvalNodeData.is_alert_notification = false;
      // this.approvalNodeData.is_alert_notification = false;
      // this.approvalNodeData.is_alert_prev_approver = false;
      // 2021-01-11 改为一个通知 brain
      // if (index0 >= 0) {
      //   this.approvalNodeData.is_alert_notification = true;
      // }
      // if (index1 >= 0) {
      //   this.approvalNodeData.is_alert_prev_approver = true;
      // }
      if (index0 >= 0) {
        this.approvalNodeData.is_alert_notification = true;
      }
    },
    copySender(val) {
      if (val == -1 || val == null || val == 0 || val == 1) {
        this.approvalNodeData.forJob_cc = [];
        this.approvalNodeData.Staffs_cc = [];
        this.approvalNodeData.correlation_cc = [];
        this.approvalNodeData.applicantMan_cc = "";
        this.approvalNodeData.applicantHeader_cc = "";
      }
      if (val == 2) {
        this.approvalNodeData.Staffs_cc = [];
        this.approvalNodeData.correlation_cc = [];
        this.approvalNodeData.applicantMan_cc = "";
        this.approvalNodeData.applicantHeader_cc = "";
      }
      if (val == 3) {
        this.approvalNodeData.forJob_cc = [];
        this.approvalNodeData.applicantMan_cc = "";
        this.approvalNodeData.correlation_cc = [];
        this.approvalNodeData.applicantHeader_cc = "";
      }
      if (val == 4) {
        this.approvalNodeData.forJob_cc = [];
        this.approvalNodeData.Staffs_cc = [];
        this.approvalNodeData.correlation_cc = [];
        this.approvalNodeData.applicantHeader_cc = "";
      }
      if (val == 5) {
        this.approvalNodeData.Staffs_cc = [];
        this.approvalNodeData.forJob_cc = [];
        this.approvalNodeData.correlation_cc = [];
        this.approvalNodeData.applicantMan_cc = "";
      }
      if (val == 6) {
        this.approvalNodeData.forJob_cc = [];
        this.approvalNodeData.Staffs_cc = [];
        this.approvalNodeData.applicantMan_cc = "";
        this.approvalNodeData.correlation_cc = [];
        this.approvalNodeData.applicantHeader_cc = "";
      }
      if (val == 7) {
        this.approvalNodeData.forJob_cc = [];
        this.approvalNodeData.Staffs_cc = [];
        this.approvalNodeData.applicantMan_cc = "";
        this.approvalNodeData.applicantHeader_cc = "";
      }
      this.approvalNodeData.is_leader_of_sender_cc = false;
      this.approvalNodeData.is_leader_of_applicant_cc = false;
      this.approvalNodeData.is_for_job_cc = false;
      this.approvalNodeData.is_for_ship_cc = false;
      this.approvalNodeData.is_for_staff_cc = false;
      this.approvalNodeData.is_for_applicant_cc = false;
      this.approvalNodeData.is_for_applicantheader_cc = false;
      this.approvalNodeData.approval_org_level_uuid_cc = "";
      switch (val) {
        case null:
          this.approvalNodeData.is_leader_of_sender_cc = false;
          break;
        case 0:
          this.approvalNodeData.is_leader_of_sender_cc = true;
          break;
        case 1:
          this.approvalNodeData.is_leader_of_applicant_cc = true;
          break;
        case 2:
          this.approvalNodeData.is_for_job_cc = true;
          break;
        case 3:
          this.approvalNodeData.is_for_staff_cc = true;
          break;
        case 4:
          this.approvalNodeData.is_for_applicant_cc = true;
          break;
        case 5:
          this.approvalNodeData.is_for_applicantheader_cc = true;
          break;
        case 6:
          this.approvalNodeData.approval_org_level_uuid_cc =
            this.curAppInfo["user"]["org_level_uuid"];
          break;
        case 7:
          this.approvalNodeData.is_for_ship_cc = true;
          break;
        default:
          break;
      }
    },
    approvers(val) {
      if (val == 0 || val == 1) {
        this.approvalNodeData.forJob = [];
        this.approvalNodeData.Staffs = [];
        this.approvalNodeData.correlation = [];
        this.approvalNodeData.applicantMan = "";
        this.approvalNodeData.applicantHeader = "";
      }
      if (val == 2) {
        this.approvalNodeData.Staffs = [];
        this.approvalNodeData.correlation = [];
        this.approvalNodeData.applicantMan = "";
        this.approvalNodeData.applicantHeader = "";
      }
      if (val == 3) {
        this.approvalNodeData.forJob = [];
        this.approvalNodeData.correlation = [];
        this.approvalNodeData.applicantMan = "";
        this.approvalNodeData.applicantHeader = "";
      }
      if (val == 4) {
        this.approvalNodeData.forJob = [];
        this.approvalNodeData.Staffs = [];
        this.approvalNodeData.correlation = [];
        this.approvalNodeData.applicantHeader = "";
      }
      if (val == 5) {
        this.approvalNodeData.Staffs = [];
        this.approvalNodeData.forJob = [];
        this.approvalNodeData.correlation = [];
        this.approvalNodeData.applicantMan = "";
      }
      if (val == 6) {
        this.approvalNodeData.forJob = [];
        this.approvalNodeData.Staffs = [];
        this.approvalNodeData.applicantMan = "";
        this.approvalNodeData.correlation = [];
        this.approvalNodeData.applicantHeader = "";
      }
      if (val == 7) {
        this.approvalNodeData.forJob = [];
        this.approvalNodeData.Staffs = [];
        this.approvalNodeData.applicantMan = "";
        this.approvalNodeData.applicantHeader = "";
      }
      this.approvalNodeData.is_leader_of_sender = false;
      this.approvalNodeData.is_leader_of_applicant = false;
      this.approvalNodeData.is_for_job = false;
      this.approvalNodeData.is_for_staff = false;
      this.approvalNodeData.is_for_applicant = false;
      this.approvalNodeData.is_for_ship = false;
      this.approvalNodeData.is_for_applicantheader = false;
      this.approvalNodeData.approval_org_level_uuid = "";
      switch (val) {
        case 0:
          this.approvalNodeData.is_leader_of_sender = true;
          break;
        case 1:
          this.approvalNodeData.is_leader_of_applicant = true;
          break;
        case 2:
          this.approvalNodeData.is_for_job = true;
          break;
        case 3:
          this.approvalNodeData.is_for_staff = true;
          break;
        case 4:
          this.approvalNodeData.is_for_applicant = true;
          break;
        case 5:
          this.approvalNodeData.is_for_applicantheader = true;
          break;
        case 6:
          this.approvalNodeData.approval_org_level_uuid =
            this.curAppInfo["user"]["org_level_uuid"];
          break;
        case 7:
          this.approvalNodeData.is_for_ship = true;
          break;
        default:
          break;
      }
    },
  },
  data() {
    return {
      curTab: "tab-1",
      curAction: [],
      taber: [
        "label_essweb_approvalTemplate_form_dialog_step_generalLabel",
        "label_essweb_approvalTemplate_form_dialog_step_permissionLabel",
        "label_essweb_approvalTemplate_form_dialog_step_fieldLabel",
      ],
      actionList: [
        "label_essweb_approvalTemplate_form_dialog_canRedirectionItemLabel",
        "label_essweb_approvalTemplate_form_dialog_canCancelLabel",
        "label_essweb_approvalTemplate_form_dialog_canRefusalLabel",
        "label_essweb_approvalTemplate_form_dialog_canSkipLabel",
        "label_essweb_approvalTemplate_form_dialog_canViewAttachmentsLabel",
      ],
      actions: [],
      nodes: 1,
      allJob: [],
      allShip: [],
      iSEdited: false,
      allStaff: [],
      allField: [],
      notifications: [],
      approvers: "",
      copySender: -1,
      approvalNodeData: {
        flow_template_node_name: "",
        flow_template_node_description: "",
        is_allow_forward: false,
        is_allow_revoke: false,
        is_allow_rollback: false,
        is_allow_skip: false,
        is_allow_view_attachments: false,
        is_first_sequence: false,
        is_final_sequence: false,
        // is_alert_notification: false,
        is_alert_notification: false,
        // is_alert_prev_approver: false,
        is_leader_of_sender: true,
        is_leader_of_sender_cc: false,
        is_leader_of_applicant: false,
        is_leader_of_applicant_cc: false,
        is_for_job: false,
        is_for_job_cc: false,
        is_for_ship: false,
        is_for_ship_cc: false,
        forJob: [],
        forJob_cc: [],
        approval_org_level_uuid: null,
        approval_org_level_uuid_cc: null,
        is_for_staff: false,
        is_for_staff_cc: false,
        field_uuid: [],
        Staffs: [],
        Staffs_cc: [],
        correlation: [],
        correlation_cc: [],
        is_for_applicant: false,
        is_for_applicant_cc: false,
        applicantMan: "",
        applicantMan_cc: "",
        is_for_applicantheader: false,
        is_for_applicantheader_cc: false,
        applicantHeader: "",
        applicantHeader_cc: "",
        ess_workflow_template_node_allow_update_fields: [],
        ess_workflow_template_node_permission: [],
        remarks: "",
      },
      approversgangwei: [],
    };
  },
  mounted() {
    const that = this;
    this.approvalNodeData.flow_template_node_name = this.$getCommonLangKey(
      this.companyLang
    );
    this.approvalNodeData.flow_template_node_description =
      this.$getCommonLangKey(this.companyLang);
    this.getJob();
    this.getShip();
    this.$getStaffList().then((res) => {
      this.allStaff = res;
    });
    // setInterval(function() {
    //   console.log(that.approvers);
    // }, 1000);
  },
  methods: {
    jobFliter(item, queryText) {
      if (queryText) {
        let itemText = "view_fields";
        if (!this.$getCommonLangValue(item[itemText])) return false;
        const one_filter = this.$getCommonLangValue(
          item[itemText]
        ).toLowerCase();

        const searchtext = String(queryText).toLowerCase();

        return one_filter.indexOf(searchtext) > -1;
      } else return true;
    },
    shipFliter(item, queryText) {
      if (queryText) {
        let itemText = "view_fields";
        if (!this.$getCommonLangValue(item[itemText])) return false;
        const one_filter = this.$getCommonLangValue(
          item[itemText]
        ).toLowerCase();

        const searchtext = String(queryText).toLowerCase();

        return one_filter.indexOf(searchtext) > -1;
      } else return true;
    },
    getDetail: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_template_nodes",
        url: "/approval-node/get-approval-node-details/",
        data: {
          uuid: uuid,
        },
      }).then((res) => {
        let obj = res.data;
        that.curTab = "tab-1";
        if (obj) {
          that.curAction = [];
          that.actions = [];
          obj.is_allow_forward ? that.actions.push(0) : null;
          obj.is_allow_revoke ? that.actions.push(1) : null;
          obj.is_allow_rollback ? that.actions.push(2) : null;
          obj.is_allow_skip ? that.actions.push(3) : null;
          obj.is_allow_view_attachments ? that.actions.push(4) : null;
          obj.is_allow_forward ? that.curAction.push(that.actionList[0]) : null;
          obj.is_allow_revoke ? that.curAction.push(that.actionList[1]) : null;
          obj.is_allow_rollback
            ? that.curAction.push(that.actionList[2])
            : null;
          obj.is_allow_skip ? that.curAction.push(that.actionList[3]) : null;
          obj.is_allow_view_attachments
            ? that.curAction.push(that.actionList[4])
            : null;
          that.approvalNodeData.is_first_sequence = obj.is_first_sequence;
          that.approvalNodeData.is_final_sequence = obj.is_final_sequence;
          that.notifications = [];
          obj.is_alert_notification ? that.notifications.push(0) : null;
          // 2021-01-11 改为一个通知 brain
          // obj.is_alert_notification ? that.notifications.push(0) : null;
          // obj.is_alert_prev_approver ? that.notifications.push(1) : null;
          that.approvers = -1;
          obj.ess_workflow_template_node_permission[0].is_leader_of_sender === 1
            ? (that.approvers = 0)
            : null;
          obj.ess_workflow_template_node_permission[0].is_leader_of_applicant
            ? (that.approvers = 1)
            : null;
          obj.ess_workflow_template_node_permission[0].approval_postion_uuid
            ? (that.approvers = 2)
            : null;
          obj.ess_workflow_template_node_permission[0].approval_staff_uuid
            ? (that.approvers = 3)
            : null;
          obj.ess_workflow_template_node_permission[0].pre_node_approver == null
            ? null
            : (that.approvers = 4);
          obj.ess_workflow_template_node_permission[0]
            .pre_node_approver_leader == null
            ? null
            : (that.approvers = 5);
          obj.ess_workflow_template_node_permission[0].approval_org_level_uuid
            ? (that.approvers = 6)
            : null;
          obj.ess_workflow_template_node_permission[0].correlation_uuid
            ? (that.approvers = 7)
            : null;
          // 抄送
          that.copySender = -1;
          obj.ess_workflow_template_node_permission[0].cc_is_leader_of_sender ==
          0
            ? (that.copySender = -1)
            : null;
          obj.ess_workflow_template_node_permission[0]
            .cc_is_leader_of_sender === 1
            ? (that.copySender = 0)
            : null;
          obj.ess_workflow_template_node_permission[0].cc_is_leader_of_applicant
            ? (that.copySender = 1)
            : null;
          obj.ess_workflow_template_node_permission[0].cc_approval_postion_uuid
            ? (that.copySender = 2)
            : null;
          obj.ess_workflow_template_node_permission[0].cc_approval_staff_uuid
            ? (that.copySender = 3)
            : null;
          obj.ess_workflow_template_node_permission[0].cc_pre_node_approver ==
          null
            ? null
            : (that.copySender = 4);
          obj.ess_workflow_template_node_permission[0]
            .cc_pre_node_approver_leader == null
            ? null
            : (that.copySender = 5);
          obj.ess_workflow_template_node_permission[0]
            .cc_approval_org_level_uuid
            ? (that.copySender = 6)
            : null;
          obj.ess_workflow_template_node_permission[0].cc_correlation_uuid
            ? (that.copySender = 7)
            : null;
          // 抄送
          that.approvalNodeData["flow_template_node_description_save"] =
            obj.flow_template_node_description;
          that.approvalNodeData["flow_template_node_name_save"] =
            obj.flow_template_node_name;
          that.approvalNodeData.flow_template_node_name =
            that.$transOnLineCommonLangKey(
              that.companyLang,
              obj.flow_template_node_name
            );
          that.approvalNodeData.flow_template_node_description =
            that.$transOnLineCommonLangKey(
              that.companyLang,
              obj.flow_template_node_description
            );

          that.approvalNodeData.applicantMan =
            obj.ess_workflow_template_node_permission[0].pre_node_approver;
          that.approvalNodeData.applicantHeader =
            obj.ess_workflow_template_node_permission[0].pre_node_approver_leader;
          that.approvalNodeData.forJob = obj
            .ess_workflow_template_node_permission[0].approval_postion_uuid
            ? obj.ess_workflow_template_node_permission[0].approval_postion_uuid.split(
                ","
              )
            : [];
          that.approvalNodeData.Staffs = [];
          that.approvalNodeData.correlation = obj
            .ess_workflow_template_node_permission[0].correlation_uuid
            ? obj.ess_workflow_template_node_permission[0].correlation_uuid.split(
                ","
              )
            : [];
          let staff = obj.ess_workflow_template_node_permission[0]
            .approval_staff_uuid
            ? obj.ess_workflow_template_node_permission[0].approval_staff_uuid.split(
                ","
              )
            : [];
          staff.map((item) => {
            that.approvalNodeData.Staffs.push(Number(item));
          });
          // 抄送
          that.approvalNodeData.applicantMan_cc =
            obj.ess_workflow_template_node_permission[0].cc_pre_node_approver;
          that.approvalNodeData.applicantHeader_cc =
            obj.ess_workflow_template_node_permission[0].cc_pre_node_approver_leader;
          that.approvalNodeData.forJob_cc = obj
            .ess_workflow_template_node_permission[0].cc_approval_postion_uuid
            ? obj.ess_workflow_template_node_permission[0].cc_approval_postion_uuid.split(
                ","
              )
            : [];
          that.approvalNodeData.Staffs_cc = [];
          that.approvalNodeData.correlation_cc = obj
            .ess_workflow_template_node_permission[0].cc_correlation_uuid
            ? obj.ess_workflow_template_node_permission[0].cc_correlation_uuid.split(
                ","
              )
            : [];
          let staff_cc = obj.ess_workflow_template_node_permission[0]
            .cc_approval_staff_uuid
            ? obj.ess_workflow_template_node_permission[0].cc_approval_staff_uuid.split(
                ","
              )
            : [];
          staff_cc.map((item) => {
            that.approvalNodeData.Staffs_cc.push(Number(item));
          });

          // 抄送
          that.approvalNodeData.field_uuid =
            obj.ess_workflow_template_node_allow_update_fields[0].field_uuid.split(
              ","
            );
          that.approvalNodeData.remarks = obj.remarks;
          this.approvalNodeData["uuid"] = obj.uuid;
          this.approvalNodeData["nodeuuid"] =
            obj.ess_workflow_template_node_allow_update_fields[0].uuid;
          this.approvalNodeData["number"] = null;
          this.approvalNodeData["id"] = null;
          this.approvalNodeData["approver_notify_threshold"] =
            obj.approver_notify_threshold;
        }
      });
    },
    getJob: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_job_posts_select",
      }).then((res) => {
        that.allJob = res.data;
      });
    },
    getShip: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "correlation_select",
      }).then((res) => {
        that.allShip = res.data;
      });
    },
    getField: function (table) {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_approval_allow_update_columns_select",

        table_uuid: table,
      }).then((res) => {
        that.allField = res.data;
      });
    },
    // 改为底层接口 daveluo
    // getStaff: function () {
    //   const that = this;
    //   this.$Request({
    //     method: "POST",
    //     table: "mrbase_sys_staffs",
    //     url: "/staff/get-staff-list/",

    //   }).then((res) => {
    //     that.allStaff = res.data;
    //   });
    // },

    closeDialog: function () {
      this.$emit("close");
    },
    removeStaff: function (item, cc) {
      if (cc) {
        this.approvalNodeData.Staffs_cc =
          this.approvalNodeData.Staffs_cc.filter(
            (ele) => Number(ele) !== Number(item.staff_id)
          );
      } else
        this.approvalNodeData.Staffs = this.approvalNodeData.Staffs.filter(
          (ele) => Number(ele) !== Number(item.staff_id)
        );
    },
    removeJob: function (item, cc) {
      if (cc) {
        this.approvalNodeData.forJob_cc =
          this.approvalNodeData.forJob_cc.filter(
            (ele) => ele !== item.value_field
          );
      } else
        this.approvalNodeData.forJob = this.approvalNodeData.forJob.filter(
          (ele) => ele !== item.value_field
        );
    },
    removeShip: function (item, cc) {
      if (cc) {
        this.approvalNodeData.correlation_cc =
          this.approvalNodeData.correlation_cc.filter(
            (ele) => ele !== item.value_field
          );
      } else
        this.approvalNodeData.correlation =
          this.approvalNodeData.correlation.filter(
            (ele) => ele !== item.value_field
          );
    },
  },
};
</script>
